import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { authRoles } from 'app/auth';
import LunarReviewsLayout from './layouts/LunarReviewsLayout';

const PendingRunsTab = lazy(() => import('./use-cases/PendingRunsTab'));
const ReviewedRunsTab = lazy(() => import('./use-cases/ReviewedRunsTab'));
const RunDetails = lazy(() => import('./use-cases/RunDetails/RunDetails'));

const LunarReviewsConfig = {
  settings: {
    layout: {
      config: {
        footer: { display: false },
        healtheraHeader: { display: true },
      },
    },
  },
  auth: authRoles.support,
  routes: [
    {
      path: 'lunar-reviews',
      element: <LunarReviewsLayout />,
      children: [
        { path: '', element: <Navigate to="pending" replace /> },
        { path: 'pending', element: <PendingRunsTab /> },
        { path: 'reviewed', element: <ReviewedRunsTab /> },
        { path: '*', element: <Navigate to="pending" replace /> },
      ],
    },
    // Outside the layout: a run's page shows no stats or tabs. It sits under the list it is opened
    // from, which its breadcrumb returns to.
    { path: 'lunar-reviews/pending/:runId', element: <RunDetails /> },
    { path: 'lunar-reviews/reviewed/:runId', element: <RunDetails /> },
  ],
};

export default LunarReviewsConfig;
